<span class="name" [matTooltip]="name" [style.background]="bgcolor">
  {{ name }}
</span>
